import React from 'react';
import { Field, ErrorMessage } from 'formik';
import { getValueByPath } from 'helpers/utils';
import { Form } from 'react-bootstrap';
import { MenuProps, Props } from './select.type';

const Menu = ({ field, form, options, ...props }: MenuProps) => {
  const isError = Boolean(
    getValueByPath(form.errors, field.name) &&
      getValueByPath(form.touched, field.name)
  );

  return (
    <Form.Select {...field} {...props} isInvalid={isError}>
      {options.map(({ label, value }, idx) => (
        <option key={idx} value={value}>
          {label}
        </option>
      ))}
    </Form.Select>
  );
};

export default function Select(props: Props) {
  return (
    <>
      <Field {...props} component={Menu} />
      <ErrorMessage
        name={props.name}
        component="div"
        className="invalid-feedback"
      />
    </>
  );
}
